export default __webpack_public_path__ + "static/media/ecom-plan.1fe4e354.svg";